import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface ClientGroupSetDefaultParams {
    readonly externalId: string;
    readonly mode: 'set' | 'unset';
}

export type ClientGroupSetDefaultResponse = {
    value: number,
    version: string
}[];

export class ClientGroupSetDefaultCommand extends Command<ClientGroupSetDefaultParams, ClientGroupSetDefaultResponse> { }

export class ClientGroupSetDefaultCommandHandlerBase implements CommandHandler<ClientGroupSetDefaultCommand, ClientGroupSetDefaultParams, ClientGroupSetDefaultResponse> {
    private static Url = TaggedUrl.join('clients/groups/default/:externalId', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) {}

    public async handleAsync(command: ClientGroupSetDefaultCommand): Promise<ClientGroupSetDefaultResponse> {
        const url = fillPlaceholders(ClientGroupSetDefaultCommandHandlerBase.Url, { externalId: command.params?.externalId });
        const request = command.params?.mode === 'set' ? this.http.put(url) : this.http.delete(url);

        return(await request).data;
    }
}
